<p-sidebar [visible]="true"
           [position]="'right'"
           [modal]="true"
           (onHide)="onSideBarHide()"
           [style]="{width:'636px'}">

    <ng-template pTemplate="header">Create Group</ng-template>
    <ng-template pTemplate="content">
        <div class="field" style="margin-top: 20px;">
            <div>Group Name</div>
            <input pInputText [(ngModel)]="group.Name" />
        </div>
        <div class="field" style="margin-top: 30px; margin-bottom: 20px;">
            <div>Stores</div>
            <p-dropdown [options]="freeStores"
                        [(ngModel)]="selectedStoreId"
                        [optionLabel]="'Name'"
                        [optionValue]="'Id'"
                        [optionDisabled]="'disabled'"
                        (onChange)="onStoresSelect()">
            </p-dropdown>
        </div>

        <ng-container *ngIf="groupStores.length">
            <div *ngIf="groupStores.length===1">1 store</div>
            <div *ngIf="groupStores.length>1">{{groupStores.length}} stores</div>
            <div *ngFor="let store of groupStores" class="pmlcg-group-store">
                <div>{{store.Name}}</div>
                <div class="filler"></div>
                <div style="cursor: pointer;" (click)="onDeleteGroupStoreClick(store.Id)">
                    <img src="{{adminUrl}}XpressApp/assets/images/delete-cross.png" style="width: 14px;" />
                </div>
            </div>
        </ng-container>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex-row" style="padding: 30px;">
            <div class="filler"></div>
            <div>
                <button pButton type="button" label="Save"
                        [disabled]="!group.Name || !groupStores.length"
                        (click)="onSaveClick()"></button>
            </div>
        </div>
    </ng-template>
</p-sidebar>

<p-toast position="top-right"></p-toast>
